var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',_vm._b({attrs:{"data":_vm.tableData}},'el-table',_vm.tableProps,false),_vm._l((_vm.columns),function(column){return _c('el-table-column',{key:_vm.item.id,attrs:{"label":column.name,"prop":column.prop,"width":column.width || 'auto'}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }